import { FETCH_LANDING_CONFIG, SET_LANDING_CONFIG } from "../actions/config";

interface IConfigReducer {
  data: object | null; 
  isFetching: boolean;
}

const initialState: IConfigReducer = {
  data: null,
  isFetching: false
};

export default (state = initialState, action: any) => {
  switch (action.type) {
    case FETCH_LANDING_CONFIG:
      return {
        ...state,
        data: null,
        isFetching: true
      };
    case SET_LANDING_CONFIG:
      return {
        ...state,
        data: action.payload,
        isFetching: false
      };
    default:
      return state;
  }
};
